import {css} from '@emotion/react';
import styled from '@emotion/styled';

type Props = {
  active: boolean;
};

export const Image = styled.img<Props>(
  ({theme, active}) => css`
    object-fit: cover;
    outline: 5px solid transparent;
    outline-offset: -5px;
    transition: outline-color 150ms ease-in-out;
    cursor: pointer;

    ${active &&
    css`
      outline-color: ${theme.colors.borderSelection};
    `}
  `
);
